export default "__VITE_ASSET__Bdw6QScx__"